"use strict";

const InputBaseControlTextfieldComponent = require("@gluenetworks/input_base_control").Textfield;
const Renderer = require("./InputEmailControlRenderer");
const _ = require("lodash");

class InputEmailControlComponent extends InputBaseControlTextfieldComponent {
    /**
     * @schema.name Input Email Control
     * @schema.package @gluenetworks/input_email_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Textfield.InputEmail
     * @schema.events ["Placeholder", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default "Email Address"
     * @schema.configuration.placeholder.required false
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._DEFAULT_PLACEHOLDER = "Email Address";
        this._placeholder = _.get(configOptions, "placeholder", this._DEFAULT_PLACEHOLDER);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this._theme = undefined;
        this._placeholder = undefined;
        this._DEFAULT_PLACEHOLDER = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = InputEmailControlComponent;
